<ng-container *ngIf="_active">
    <ng-content></ng-content>
</ng-container>